import type { SiteConfig } from '@/types/global.d'

const site_url = process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000'

export const siteConfig: SiteConfig = {
  title: 'Çalışkan Restorasyon | Restorasyon Yapı İnşaat Sanayi Ticaret A.Ş.',
  titleEN:
    'Çalışkan Restoration | Restoration Construction Industry Trade Inc.',
  name: 'Çalışkan Restorasyon',
  nameEN: 'Çalışkan Restoration',
  description:
    'Çalışkan Restorasyon Yapı A.Ş. 2014 yılında Kemal ÇALIŞKAN tarafından kurulmuş olup ,Eski eser onarımı başta olmak üzere Üst ve Alt yapı alanlarında hizmet vermekte olan taahhüt firmasıdır.',
  descriptionEN:
    'Çalışkan Restorasyon Yapı A.Ş. was established in 2014 by Kemal ÇALIŞKAN, is a contracting company that provides services in the field of superstructure and infrastructure, especially in the restoration of historical artifacts.',
  url: site_url,
  ogImage: `${site_url}/caliskanas-og.png`,
  links: {
    twitter: 'https://twitter.com/caliskanas1',
    facebook: 'https://www.facebook.com/caliskan',
    linkedin: 'https://www.linkedin.com/company/caliskan',
    instagram: 'https://www.instagram.com/caliskanascom',
  },
  mailSupport: 'bilgi@caliskanas.com',
}

export const META_THEME_COLORS = {
  light: '#ffffff',
  dark: '#09090b',
}
